module.exports = __webpack_public_path__ + "img/home_money_plant.000fb5f3.jpg";